module.exports = __webpack_public_path__ + "images/fa-tyf-bg-banner.webp";